/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { PureComponent } from 'react';
import { number, shape, func, string } from 'prop-types';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { fileUploadURL } from 'Redux/modules/files/actions';

import styles from './FileInputURL.less';
import FileInputItem, { TYPE_FILE } from './FileInputItem';

const formatValues = list => list.map(i => i);

class FileUploadURL extends PureComponent {
  handleSelectedFile = (oldValue, newValue) => {
    const {
      field: { name, value = [] },
      form: { setFieldValue },
      onFileSelected,
    } = this.props;
    let listValue = [...value];
    if (oldValue) {
      listValue = value.map(item => (item.id === oldValue.id ? newValue : item));
    } else {
      listValue.push(newValue);
    }
    setFieldValue(name, listValue);
    onFileSelected(newValue, listValue);
  };

  handleFileRemove = removedValue => {
    const {
      field: { name, value = [] },
      form: { setFieldValue },
      onFileSelected,
    } = this.props;
    const newValue = value.filter(item => item.id !== removedValue.id);
    setFieldValue(name, newValue);
    onFileSelected(removedValue, newValue);
  };

  fileUpload = formData => {
    const { dispatch, action, token } = this.props;
    return dispatch(action(formData, token));
  };

  render() {
    const {
      field: { value, name },
      label,
      form: { touched, errors },
      maxFile,
      type,
      // eslint-disable-next-line no-shadow
      formatValues,
    } = this.props;

    const formatedValues = formatValues(value || []);

    return (
      <Form.Field error={touched && errors !== ''}>
        <span className={styles.label}>{label}</span>
        <div className={styles.container}>
          {formatedValues.map(item => (
            <FileInputItem
              key={item.id}
              onFileSelected={this.handleSelectedFile}
              fileUpload={this.fileUpload}
              fileName={name}
              value={item}
              handleFileRemove={this.handleFileRemove}
              type={type}
            />
          ))}
          {maxFile > formatedValues.length && (
            <FileInputItem
              onFileSelected={this.handleSelectedFile}
              fileUpload={this.fileUpload}
              fileName={name}
              type={type}
            />
          )}
        </div>
        {touched[name] && errors[name] && <div className={styles.error}>{errors[name]}</div>}
      </Form.Field>
    );
  }
}

const mapStateToProps = state => ({
  token: state.auth.data.token,
});

FileUploadURL.propTypes = {
  label: string,
  onFileSelected: func,
  action: func,
  formatValues: func,
  field: shape({}).isRequired,
  form: shape({}).isRequired,
  dispatch: func.isRequired,
  maxFile: number,
  type: number,
  token: string,
};

FileUploadURL.defaultProps = {
  onFileSelected: () => {},
  label: '',
  maxFile: 1,
  type: TYPE_FILE,
  action: fileUploadURL,
  formatValues,
  token: null,
};

export default connect(mapStateToProps)(FileUploadURL);
